/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API
 * API for Westbury Music
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnboardingStepsOnboardingStepsInner
 */
export interface OnboardingStepsOnboardingStepsInner {
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepsOnboardingStepsInner
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepsOnboardingStepsInner
     */
    internalIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepsOnboardingStepsInner
     */
    readableName: string;
    /**
     * 
     * @type {number}
     * @memberof OnboardingStepsOnboardingStepsInner
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStepsOnboardingStepsInner
     */
    information?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStepsOnboardingStepsInner
     */
    stepCompleted?: boolean;
}

/**
 * Check if a given object implements the OnboardingStepsOnboardingStepsInner interface.
 */
export function instanceOfOnboardingStepsOnboardingStepsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "internalIdentifier" in value;
    isInstance = isInstance && "readableName" in value;
    isInstance = isInstance && "order" in value;

    return isInstance;
}

export function OnboardingStepsOnboardingStepsInnerFromJSON(json: any): OnboardingStepsOnboardingStepsInner {
    return OnboardingStepsOnboardingStepsInnerFromJSONTyped(json, false);
}

export function OnboardingStepsOnboardingStepsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingStepsOnboardingStepsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'internalIdentifier': json['internal_identifier'],
        'readableName': json['readable_name'],
        'order': json['order'],
        'information': !exists(json, 'information') ? undefined : json['information'],
        'stepCompleted': !exists(json, 'step_completed') ? undefined : json['step_completed'],
    };
}

export function OnboardingStepsOnboardingStepsInnerToJSON(value?: OnboardingStepsOnboardingStepsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'internal_identifier': value.internalIdentifier,
        'readable_name': value.readableName,
        'order': value.order,
        'information': value.information,
        'step_completed': value.stepCompleted,
    };
}

